import { render, staticRenderFns } from "./CategorySubCreate.vue?vue&type=template&id=581e10c2"
import script from "./CategorySubCreate.vue?vue&type=script&lang=js"
export * from "./CategorySubCreate.vue?vue&type=script&lang=js"
import style0 from "./CategorySubCreate.vue?vue&type=style&index=0&id=581e10c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports